import getStore from '../store';
import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs/lib/legacy';

/**
 * Shows cancellation editor
 */
export default action('closeNotesEditor')(function closeNotesEditor(id: ClientItemId) {
    getStore().meetingIdToNotesViewStateMap.delete(id.Id);
});
